import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { AutoHideSnackbar } from 'common/Snackbar/AutoHideSnackbar.tsx';
import { AlertTitle } from 'common/Snackbar/AlertTitle.tsx';

export type ImportError = {
  title: string;
  description: string[];
};

export type UploadSnackbarProps = {
  importError: ImportError | null;
  onClose: () => void;
};

export const UploadSnackbar: React.FC<UploadSnackbarProps> = ({ importError, onClose }) => {
  return (
    <Stack>
      <AutoHideSnackbar open={!!importError} severity="error" onClose={onClose}>
        <AlertTitle>{importError?.title || ''}!</AlertTitle>
        {importError?.description.length === 1 && (
          <Typography key={importError.description[0]} variant="text1" color="text.white">
            {importError.description[0]}
          </Typography>
        )}
        {importError?.description.length &&
          importError?.description.length > 1 &&
          importError?.description.map((message, index) => (
            <li key={message}>
              <Typography variant="text1" color="text.white">
                {message}
              </Typography>
              {index + 1 < importError?.description.length && <br />}
            </li>
          ))}
      </AutoHideSnackbar>
    </Stack>
  );
};
